/* eslint-disable indent */
/* eslint-disable no-alert */
import React from 'react';
import { PropTypes } from 'prop-types';
import { translate } from 'react-i18next';
import { css } from 'emotion';
import _ from 'lodash';
import Dropdown from '~/modules/coreUI/components/legacies/Dropdownv2';
import withRefetchConsumer from '~/modules/core/utils/relayHelpers/withRefetchConsumer';
import { cssMediaMax, cssMediaMin } from '~/modules/core/utils/cssHelpers/cssMedia';
import objectsDeepNotEqualComparison from '~/modules/core/utils/jsHelpers/objectsDeepComparison';

export const ITEMS_LIST_SORTING_DROPDOWN_KEY = 'items_list_sorting_dropdown';

const customDropdownStyles = props => css`
  .Dropdown-control {
    ${cssMediaMin.tablet`
      min-width: ${10 * props.theme.paddings.large}px;
    `}
    padding-top: ${props.theme.paddings.medium}px;
    padding-bottom: ${props.theme.paddings.medium}px;
    ${
      props.direction === 'rtl'
        ? `
          padding-right: ${props.theme.paddings.medium}px;
          padding-left: ${props.theme.paddings.xxxxxLarge + 12}px;
        `
        : `
          padding-left: ${props.theme.paddings.medium}px;
          padding-right: ${props.theme.paddings.xxxxxLarge + 12}px;
        `
    }
    ${cssMediaMax.xsmall`
      padding-top: ${props.theme.paddings.small}px;
      padding-bottom: ${props.theme.paddings.small}px;
      padding-right: ${props.theme.paddings.xxxxLarge}px;
      height: ${props.theme.new.spacer * 3}px;
      line-height: 1.1;
    `};
    color: ${props.theme.colors.primary};
    border-width: ${props.theme.borders.size.thin}px;
    border-style: solid;
    border-color: ${props.theme.colors.primary};
    border-radius: ${1.5 * props.theme.borders.radius.small}px;
    .Dropdown-placeholder.is-selected {
      ${cssMediaMax.xsmall`
        max-width: 90px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      `}
    }
  }
  .Dropdown-menu {
    border-radius:  ${1.5 * props.theme.borders.radius.small}px;
  }
  .Dropdown-arrow, .is-open .Dropdown-arrow {
    ${cssMediaMax.xsmall`
      top: ${props.theme.paddings.small}px;
    `};
    color: ${props.theme.colors.primary};
  }
  .Dropdown-option.is-selected {
    color: ${props.theme.colors.primary};
  }
`;

const changeArrayShape = options => options.map(option => ({
    value: option.name,
    label: option.display_name,
  }));

const getCurrenValue = (sortingInfo) => {
  if (!sortingInfo) {
    return null;
  }
  const selectedEntry = sortingInfo.find(entry => entry.selected) || sortingInfo[0];

  return {
    value: selectedEntry.name,
    label: selectedEntry.display_name,
  };
};

class SortingDropdown extends React.Component {
  static getDerivedStateFromProps(nextProps, currentState) {
    const newSortingProp = nextProps.refetchData && nextProps.refetchData.sortingInfo;

    const newPropsReceived = objectsDeepNotEqualComparison(
      currentState.prevSortingProp,
      newSortingProp,
    );

    if (newPropsReceived) {
      return {
        // Workaround to keep the previously received props shown
        sortingInfo: newSortingProp ? _.cloneDeep(newSortingProp) : currentState.sortingInfo,
        prevSortingProp: _.cloneDeep(newSortingProp),
      };
    }
    return null;
  }

  state = {
    sortingInfo: null,
    prevSortingProp: null, // eslint-disable-line
  };

  setSortVariables = (sortVariables) => {
    if (sortVariables === 'nearest') {
      this.props.refetchForceLoadingState();

      navigator.geolocation.getCurrentPosition((position) => {
        const coords = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        };

        this.props.refetchMethod(
          ITEMS_LIST_SORTING_DROPDOWN_KEY,
          {
            sort: sortVariables,
            coordinates: coords,
          },
          '^.input',
        );
      }, this.showError);
    } else {
      this.props.refetchMethod(ITEMS_LIST_SORTING_DROPDOWN_KEY, { sort: sortVariables }, '^.input');
    }
  };

  showError = (error) => {
    // Workaround later we will replace it with toast alert
    switch (error.code) {
      case error.PERMISSION_DENIED:
        alert('User denied the request for Geolocation.');
        break;
      case error.POSITION_UNAVAILABLE:
        alert('Location information is unavailable.');
        break;
      case error.TIMEOUT:
        alert('The request to get user location timed out.');
        break;
      default:
        alert('An unknown error occurred while getting your location');
        break;
    }
  }

  render = () => (
    <Dropdown
      lng={this.props.lng}
      customStyles={customDropdownStyles}
      options={this.state.sortingInfo ? changeArrayShape(this.state.sortingInfo) : []}
      onChange={(val) => {
        this.setState({
          sortingInfo: null,
        });
        this.setSortVariables(val.value);
      }}
      currentValue={getCurrenValue(this.state.sortingInfo)}
    />
  );
}

SortingDropdown.propTypes = {
  queryResult: PropTypes.shape({}).isRequired,
}.isRequired;

export default translate('ecommerceProducts')(withRefetchConsumer(SortingDropdown));
